/* KEX home motion 2026
 * Lenguaje de entrada inspirado en la referencia MarketPro: crecimiento sutil,
 * revelado escalonado y lectura lateral en carruseles. Sin dependencias.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function all(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function reveal(el, mode, delay) {
    if (!el || el.dataset.kexHomeMotion) return;
    el.dataset.kexHomeMotion = 'true';
    el.setAttribute('data-kx-reveal', mode || 'up');
    if (delay) el.style.setProperty('--kx-delay', delay + 'ms');
  }

  function revealGroup(section, itemSelector, mode, step) {
    var root = document.querySelector(section);
    if (!root) return;
    root.setAttribute('data-kx-stagger', String(step || 70));
    all(itemSelector, root).forEach(function (item, index) {
      reveal(item, mode, Math.min(index, 8) * (step || 70));
    });
  }

  function decorate(scope) {
    var root = scope || document;
    if (!document.body.classList.contains('template-index') && !document.querySelector('[data-kexs-hero]')) return;
    document.documentElement.classList.add('kex-home-motion-page');

    all([
      '.kexv-home__panel',
      '.kex-home-project-banner__inner',
      '.shoppable-image__inner',
      '.kex-recipes-news__inner',
      '.kx-footer__newsletter'
    ].join(','), root).forEach(function (el) { reveal(el, 'grow'); });

    all([
      '.kexv-home__content',
      '.kexs-products__head',
      '.kx-loc .kx-head',
      '.academy-editorial .section__header',
      '.kex-recipes-news__intro'
    ].join(','), root).forEach(function (el, index) { reveal(el, 'up', (index % 3) * 70); });

    revealGroup('.kexs-catalog-rail', '.kexs-catalog-rail__group:first-child .kexs-catalog-rail__card', 'grow', 55);
    revealGroup('.kexs-products', '.kexs-products__panel:not([hidden]) .kexs-product', 'left', 65);
    revealGroup('.kexs-services', '.kexs-service', 'up', 70);
    revealGroup('.kx-loc', '.kx-loc__card', 'grow', 70);
    revealGroup('.academy-editorial', '.slider__item', 'left', 65);

    if (window.KX && typeof window.KX.boot === 'function') window.KX.boot(root);
    if (reduced) all('[data-kex-home-motion]', root).forEach(function (el) { el.classList.add('is-in'); });
  }

  function boot(scope) {
    window.requestAnimationFrame(function () { decorate(scope || document); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:select', function (event) { boot(event.target); });
})();
